import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { CheckNumberField } from '../../Helpers/fieldValidator';
import { makeStyles,TextField } from '@material-ui/core';
import { toast } from 'react-toastify';

export default function TransportPrice100Kg(props) {

    const [transportPrice100Kg, setTransportPrice100Kg] = useState(null)
    const classes = useStyles();

    useEffect(() => {

        if (props.chosenValue) {
            if (JSON.stringify(transportPrice100Kg) !== JSON.stringify(props.chosenValue)) {
                setTransportPrice100Kg(props.chosenValue)
            }
        }else{
            if (transportPrice100Kg !== "0") {
                setTransportPrice100Kg("0")
            }
        }      
    
      }, [])

    const setNextStep = () => {
        props.setContent(transportPrice100Kg);
        validate();
    }

    const validate = () => {
        let isValid = CheckNumberField(transportPrice100Kg);

        if (!isValid[0]) {
            toast.error(isValid[1], { position: toast.POSITION.TOP_CENTER })
        } else {
            props.SetNext();
        }
    }

    const onChangeText = (e) => {
        setTransportPrice100Kg(e.target.value)
    }  

    return (
        <div className={classes.container}>
            <TextField id="outlined-search" label="" type="number" value={transportPrice100Kg} variant="outlined" placeholder={"Enter transport price per 100 kg"} className={classes.uiTextField} size="small" onChange={(e) => onChangeText(e)} />
            <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
        </div>
    )

}

const useStyles = makeStyles({
    uiTextField: {
        width: "100%",
        backgroundColor: "white"
    },
    container: {
        marginTop: "30px",
    }
})

